@let loading = isLoading();

<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'ACCOUNT.SUPPORT_ACCESS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" (click)="onCancel()"></span>
  </div>
  <div class="body">
    @if (loading) {
      <div class="flex-row center-center h-100 w-100">
        <ui-preloader [color]="loaderColor.blue"></ui-preloader>
      </div>
    } @else {
      <div class="support-access-settings">
        <div class="support-access-row">
          <div class="flex-col gap-4">
            <span class="support-access-label">{{ 'ACCOUNT.SUPPORT_ACCESS.FORM.ENABLED' | translate }}</span>
            <span class="support-access-description">{{ 'ACCOUNT.SUPPORT_ACCESS.FORM.ENABLED_DESCRIPTION' | translate }}</span>
          </div>
          <ui-toggle #toggleRef [formControl]="toggleControl"></ui-toggle>
        </div>
        <div class="support-access-row">
          <div class="flex-col gap-4">
            <span class="support-access-label">{{ 'ACCOUNT.SUPPORT_ACCESS.FORM.DURATION' | translate }}</span>
            <span class="support-access-description">{{ 'ACCOUNT.SUPPORT_ACCESS.FORM.DURATION_DESCRIPTION' | translate }}</span>
          </div>
          <mat-select
            class="ui-selector ui-selector-40 support-access-select"
            [ngModel]="selectedDurationDays()"
            (ngModelChange)="onDurationChange($event)"
          >
            @for (duration of durationOptions; track duration) {
              <mat-option [value]="duration">
                @if (duration === lifetimeDurationDays) {
                  {{ 'ACCOUNT.SUPPORT_ACCESS.FORM.LIFETIME' | translate }}
                } @else {
                  {{ duration }} {{ 'ACCOUNT.SUPPORT_ACCESS.FORM.DAYS' | translate }}
                }
              </mat-option>
            }
          </mat-select>
        </div>
      </div>
    }
  </div>
  <div class="footer flex-row end-center">
    <ui-button
      (click)="onCancel()"
      [text]="'COMMON.CANCEL' | translate"
      type="default"
    ></ui-button>
    <ui-button
      (click)="onSave()"
      [disabled]="loading"
      [text]="'COMMON.SAVE' | translate"
      type="primary"
    ></ui-button>
  </div>
</div>
